// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object')
  , $keys    = require('./_object-keys');

require('./_object-sap')('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/core-js/modules/es6.object.keys.js
// module id = 61
// module chunks = 0 3 5